module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/100k-active-0107717d66cda77d0b81d938a1f90dd7.png";